import React, { memo, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ResultsToggle from '../ResultsToggle/ResultsToggle';
import './style.scss';

const MatchingTicketSection = ({ ticket, id }) => {
  const { revisions, positiveResponse, workLog } = ticket;
  const url = `${process.env.REACT_APP_BASE_PATH}/${process.env.REACT_APP_SUPERVISOR_TICKET_DETAILS}/${id}`;

  const [expandedSections, setExpandedSections] = useState({
    revisions: false,
    positiveResponses: false,
    workLogs: false,
  });

  const toggleSection = section => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  // Helper function to flatten nested revisions
  const flattenRevisions = (dataObject, excludeFirstRevision = false) => {
    if (!dataObject) return null;

    const flattened = {};
    Object.values(dataObject).forEach(item => {
      if (item.revisions) {
        Object.entries(item.revisions).forEach(([key, value]) => {
          // Skip first revision if flag is set (revisions starting with "1-")
          if (excludeFirstRevision && key.startsWith('1-')) {
            return;
          }
          flattened[key] = value;
        });
      }
    });

    return Object.keys(flattened).length > 0 ? flattened : null;
  };

  const flattenedPositiveResponse = flattenRevisions(positiveResponse, true);
  const flattenedWorkLog = flattenRevisions(workLog, true);

  return (
    <div className={'matching-ticket'} key={id}>
      <a href={url} target="_blank" rel="noopener noreferrer" className="ticket-link">
        <div className={'ticket-label'}>
          {id}
          <span className="external-icon">↗</span>
        </div>
      </a>

      {revisions && (
        <div className={'revision-section'}>
          <div className={'section-title'} onClick={() => toggleSection('revisions')}>
            <span className={`expand-icon ${expandedSections.revisions ? 'expanded' : ''}`}>
              ▶
            </span>
            Revisions ({Object.keys(revisions).length})
          </div>
          {expandedSections.revisions && (
            <div className="section-content">
              <ResultsToggle results={revisions} />
            </div>
          )}
        </div>
      )}
      {flattenedPositiveResponse && (
        <div className={'response-section'}>
          <div className={'section-title'} onClick={() => toggleSection('positiveResponses')}>
            <span className={`expand-icon ${expandedSections.positiveResponses ? 'expanded' : ''}`}>
              ▶
            </span>
            Positive Responses ({Object.keys(flattenedPositiveResponse).length})
          </div>
          {expandedSections.positiveResponses && (
            <div className="section-content">
              <ResultsToggle results={flattenedPositiveResponse} />
            </div>
          )}
        </div>
      )}
      {flattenedWorkLog && (
        <div className={'worklog-section'}>
          <div className={'section-title'} onClick={() => toggleSection('workLogs')}>
            <span className={`expand-icon ${expandedSections.workLogs ? 'expanded' : ''}`}>▶</span>
            Work Logs ({Object.keys(flattenedWorkLog).length})
          </div>
          {expandedSections.workLogs && (
            <div className="section-content">
              <ResultsToggle results={flattenedWorkLog} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

MatchingTicketSection.propTypes = {
  ticket: PropTypes.shape({
    revisions: PropTypes.object,
    positiveResponse: PropTypes.object,
    workLog: PropTypes.object,
  }).isRequired,
  id: PropTypes.string.isRequired,
};

export default memo(MatchingTicketSection);
